'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductListController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _common = require('../common/common.module');

var _common2 = _interopRequireDefault(_common);

var _productList = require('./product-list.directive');

var _productCard = require('./product-card/product-card.directive');

var _imageSlider = require('./image-slider/image-slider.directive');

var _index = require('./image-uploader/index');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _index2 = require('./edit-product/index');

var _index3 = _interopRequireDefault(_index2);

var _index4 = require('./product-details/index');

var _index5 = _interopRequireDefault(_index4);

var _products = require('ifeis-isomorphic/lib/redux/actions/products');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductListController = exports.ProductListController = function () {
  function ProductListController($ngRedux, $scope, $mdDialog, msgService) {
    _classCallCheck(this, ProductListController);

    this.svc = {
      $ngRedux: $ngRedux,
      $scope: $scope,
      $mdDialog: $mdDialog,
      msgService: msgService
    };

    this.activate();
  }

  _createClass(ProductListController, [{
    key: 'activate',
    value: function activate() {
      var _this = this;

      this.feisId = this.feis.get('id');
      this.errorChecking();
      this.svc.$ngRedux.dispatch((0, _products.getProductsAndImages)(this.feisId, this.svc.$ngRedux.getState));
      this.unsubscribe = this.svc.$ngRedux.connect((0, _mapStateToController2.default)(this.feisId))(this);

      this.svc.$scope.$on('$destroy', function (event) {
        _this.unsubscribe();
        _this.svc.$ngRedux.dispatch((0, _products.deleteProducts)(_this.feisId));
      });
    }
  }, {
    key: 'deleteProductDialog',
    value: function deleteProductDialog(product) {
      var _this2 = this;

      var confirm = this.svc.$mdDialog.confirm().title('Are you sure you want to delete "' + product.name + '" ?').textContent('').ariaLabel('Confirm deletion').targetEvent(event).ok('DELETE').cancel('CANCEL');

      this.svc.$mdDialog.show(confirm).then(function () {
        _this2.svc.$ngRedux.dispatch((0, _products.deleteProduct)(_this2.feisId, product.id)).then(function (resp) {
          if (resp.errors) {
            _this2.svc.msgService.displayErrorMsg('Error deleting product: ' + resp.errors.statusText);
            return Promise.reject();
          }
        }).catch(function (e) {
          return _this2.svc.msgService.displayErrorMsg('Error deleting product: ' + e);
        });
      });
    }
  }, {
    key: 'editProductDialog',
    value: function editProductDialog(product) {
      if (this.editable) {
        this.showEditProductDialog(this.feisId, product, this.feis);
      } else {
        this.showProductDetailsDialog(product);
      }
    }
  }, {
    key: 'errorChecking',
    value: function errorChecking() {
      if (!this.feisId) {
        console.log('PRODUCT_LIST_ERROR: feis-id prop must be provided by parent.');
      }
    }
  }, {
    key: 'newProduct',
    value: function newProduct() {
      this.showEditProductDialog(this.feisId, undefined, this.feis);
    }
  }, {
    key: 'showEditProductDialog',
    value: function showEditProductDialog(feisId) {
      var product = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var feis = arguments[2];

      this.svc.$mdDialog.show({
        parent: angular.element(document.body),
        escapeToClose: false,
        controllerAs: '$ctrl',
        controller: _index3.default,
        template: require('./edit-product/tpl.html'),
        bindToController: true,
        locals: {
          feisId: feisId,
          productId: product.id,
          feis: feis
        }
      });
    }
  }, {
    key: 'showProductDetailsDialog',
    value: function showProductDetailsDialog(product) {
      this.svc.$mdDialog.show({
        parent: angular.element(document.body),
        escapeToClose: true,
        controllerAs: '$ctrl',
        controller: _index5.default,
        template: require('./product-details/tpl.html'),
        bindToController: true,
        locals: {
          product: product
        }
      });
    }
  }]);

  return ProductListController;
}();

exports.default = angular.module('ifeis.product-list', ['ngMaterial', 'ifeis.common']).directive('fProductList', _productList.ProductListDirective).directive('fProductCard', _productCard.ProductCardDirective).directive('fImageSlider', _imageSlider.ImageSliderDirective).directive('fImageUploader', function () {
  return new _index.ImageUploaderDirective();
});


//////////////////
// WEBPACK FOOTER
// ./product-list/index.js
// module id = 214
// module chunks = 0